import UnitAvailableTag from '@/components/UnitAvailableTag/UnitAvailableTag';
import type { Property } from '@/domain/properties';
import type { Unit } from '@/domain/units';
import { getAddressDescription } from '@/utils/addresses';
import { formatCurrency } from '@/utils/currency';
import { formatDate } from '@/utils/dates';
import type { FC } from 'react';

interface Props {
  unit: Unit;
  property: Property;
}

const PropertyAddressAndPrice: FC<Props> = ({ property, unit }) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between">
      <div className="mb-4 md:mb-0">
        <div className="flex items-center gap-3 mb-2">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            {getAddressDescription(property.address)}
          </h1>
          <UnitAvailableTag unitListingStatus={unit.listingStatus} />
        </div>
        <p className="text-lg text-gray-600">{unit.floorPlanName}</p>
      </div>
      <div className="text-left md:text-right">
        <div className="text-4xl font-bold text-primary-600 mb-2">
          {formatCurrency(unit.listedRent)}
          <span className="text-xl text-gray-600">/month</span>
        </div>
        <p className="text-sm text-gray-600">Available {formatDate(unit.readyDate)}</p>
      </div>
    </div>
  );
};

export default PropertyAddressAndPrice;
